
/**
 * Creates the merchant Callback URL
 */
const createMerchantCallbackUrl = ({ callbackUrl = '', srciTxId, status = 'cancel' }) => {
  if (!callbackUrl) return ''
  const url = new URL(callbackUrl)

  // if the status is not success, we will not have a transaction id
  if (srciTxId) {
    url.searchParams.set('oauth_token', srciTxId)
    url.searchParams.set('oauth_verifier', srciTxId)
  }

  url.searchParams.set('mpstatus', status)
  return url.toString()
}

export { createMerchantCallbackUrl }
